import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Quote } from 'lucide-react';
export function Problem() {
  return <section className="bg-cream-50 py-20 md:py-32 px-6" data-id="element-160">
      <div className="max-w-4xl mx-auto relative" data-id="element-161">
        <FadeIn data-id="element-162">
          <div className="absolute -top-10 -left-6 md:-left-12 text-gold-400/20" data-id="element-163">
            <Quote size={120} className="transform rotate-180" data-id="element-164" />
          </div>

          <div className="relative z-10" data-id="element-165">
            <h2 className="font-serif text-3xl md:text-4xl text-navy-900 font-bold mb-8" data-id="element-166">
              El mito del "cerebro viejo"
            </h2>

            <div className="space-y-6 text-xl md:text-2xl text-charcoal-800 leading-relaxed font-serif italic" data-id="element-167">
              <p data-id="element-168">
                Durante años, nos han hecho creer que el deterioro mental es una
                parte inevitable de "hacerse mayor". Nos dicen que después de
                los 65 años, nuestro cerebro simplemente se apaga.
              </p>
              <p data-id="element-169">
                La frustración de no encontrar el nombre de una amiga en una
                cena, la confusión al manejar sus propias finanzas o el miedo de
                repetir la misma historia tres veces son señales de un cerebro
                que no está "viejo", sino simplemente desentrenado por falta de
                estímulos específicos en nuestro idioma y cultura.
              </p>
            </div>

            <div className="w-24 h-1 bg-gold-400 mt-12 rounded-full" data-id="element-170"></div>
          </div>
        </FadeIn>
      </div>
    </section>;
}